import { Injectable } from "@angular/core";
import { IPartnerDetail } from "../interface/partner.interface";
import { PartnerService } from "./partner.service";
import * as $ from "jquery";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { HttpClient } from "@microsoft/signalr";

@Injectable({
  providedIn: "root"
})
export class PartnerDataService {
  public partnerDetail: IPartnerDetail;

  constructor(
    private partnerService: PartnerService,
    private titleService: Title
  ) {}

  async getPartnerDetail(code: string): Promise<void> {
    this.partnerDetail = await this.partnerService.getPartnerByCode(code);

    this.titleService.setTitle(this.partnerDetail?.title);

    // Change favicon
    if (code && this.partnerDetail?.iconUrl) {
      $("link[rel*='icon']").attr("href", this.partnerDetail?.iconUrl);
    }

    document.documentElement.style.setProperty(
      "--secondary-color",
      this.partnerDetail.secondaryColor
    );
    document.documentElement.style.setProperty(
      "--secondary-text-color",
      this.partnerDetail.textColor
    );
    document.documentElement.style.setProperty(
      "--secondary-sub-color",
      this.partnerDetail.secondarySubColor
    );
    document.documentElement.style.setProperty(
      "--primary-color",
      this.partnerDetail.primaryColor
    );
    document.documentElement.style.setProperty(
      "--primary-sub-color",
      this.partnerDetail.primarySubColor
    );
    document.documentElement.style.setProperty(
      "--step-1",
      `url(${this.partnerDetail.stepOneImg})`
    );
    document.documentElement.style.setProperty(
      "--step-1-active",
      `url(${this.partnerDetail.stepOneActiveImg})`
    );
    document.documentElement.style.setProperty(
      "--step-2",
      `url(${this.partnerDetail.stepTwoImg})`
    );
    document.documentElement.style.setProperty(
      "--step-2-active",
      `url(${this.partnerDetail.stepTwoActiveImg})`
    );
  }
}
